class GlymedSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slidesWrapper = this.querySelector('.slideshow-wrapper');
    this.slides = this.querySelectorAll('.slideshow-slide');
    this.dots = this.querySelectorAll('.pagination-dot');
    this.totalSlides = this.slides.length;
    this.currentSlide = 1; // Start at 1 (because of prepended clone)
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.speed) * 1000;
    this.timer = null;
    this.isHovering = false;
    this.isAnimating = false;

    // Navigation elements
    this.prevBtn = this.querySelector('.slideshow-arrow--prev');
    this.nextBtn = this.querySelector('.slideshow-arrow--next');

    // Bindings
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.handleDotClick = this.handleDotClick.bind(this);

    this.init();
  }

  init() {
    if (this.totalSlides < 2) return;

    // Seamless Loop: Clone Last (Prepend) and First (Append)
    const firstClone = this.slides[0].cloneNode(true);
    const lastClone = this.slides[this.totalSlides - 1].cloneNode(true);
    
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');

    this.slidesWrapper.prepend(lastClone);
    this.slidesWrapper.appendChild(firstClone);

    // Initial Position (Show real slide 1)
    this.updateSlider(false);

    // Arrow Event Listeners
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => {
      this.pauseAutoplay();
      this.prevSlide();
    });
    
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => {
      this.pauseAutoplay();
      this.nextSlide();
    });

    // Dot Event Listeners
    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.handleDotClick);
    });

    // Start Autoplay if enabled
    if (this.autoplayEnabled) {
      this.startAutoplay();
      
      // Pause on hover
      this.addEventListener('mouseenter', () => {
        this.isHovering = true;
        this.pauseAutoplay();
      });
      
      this.addEventListener('mouseleave', () => {
        this.isHovering = false;
        this.startAutoplay();
      });
    }
  }

  updateSlider(enableTransition = true) {
    if (enableTransition) {
      this.slidesWrapper.style.transition = 'transform 0.5s ease-in-out';
    } else {
      this.slidesWrapper.style.transition = 'none';
    }

    const translateX = -(this.currentSlide * 100);
    this.slidesWrapper.style.transform = `translateX(${translateX}%)`;
    
    let dotIndex = this.currentSlide - 1;
    if (this.currentSlide === 0) dotIndex = this.totalSlides - 1;
    if (this.currentSlide === this.totalSlides + 1) dotIndex = 0;

    this.dots.forEach(dot => dot.classList.remove('active'));
    if(this.dots[dotIndex]) {
        this.dots[dotIndex].classList.add('active');
    }
  }

  nextSlide() {
    if (this.isAnimating) return; 

    this.currentSlide++;
    this.updateSlider(true);

    // Check if we hit Last Clone
    if (this.currentSlide === this.totalSlides + 1) {
      this.isAnimating = true;
      setTimeout(() => {
        this.currentSlide = 1; // Real First
        this.updateSlider(false);
        this.isAnimating = false;
      }, 500);
    }
  }

  prevSlide() {
    if (this.isAnimating) return;

    this.currentSlide--;
    this.updateSlider(true);

    if (this.currentSlide === 0) {
      this.isAnimating = true;
      setTimeout(() => {
        this.currentSlide = this.totalSlides; // Real Last
        this.updateSlider(false);
        this.isAnimating = false;
      }, 500);
    }
  }

  handleDotClick(e) {
    if (this.isAnimating) return;
    this.pauseAutoplay();
    const index = parseInt(e.target.dataset.index);
    this.currentSlide = index + 1;
    this.updateSlider(true);
  }

  startAutoplay() {
    if (this.isHovering) return;
    if (!this.timer) {
      this.timer = setInterval(this.nextSlide, this.autoplaySpeed);
    }
  }

  pauseAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

// Define the Web Component
customElements.define('glymed-slideshow', GlymedSlideshow);